import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z","key":"svg-0"}],["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}],["path",{"d":"M9 10h.01","key":"svg-2"}],["path",{"d":"M10 14v2a2 2 0 0 0 4 0v-2","key":"svg-3"}],["path",{"d":"M15.5 14h-7","key":"svg-4"}],["path",{"d":"M17 10c-.5 -1 -2.5 -1 -3 0","key":"svg-5"}]]

const IconMoodTongueWink = createReactComponent('outline', 'mood-tongue-wink', 'MoodTongueWink', __iconNode);

export default IconMoodTongueWink;